import React, { useState } from 'react';

const PHONE = '528139147429';
const MESSAGE = 'Hola, necesito ayuda con mi pedido en NubesMty';
const WA_URL = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="fixed z-50 flex items-center gap-2.5 cursor-pointer select-none"
      style={{
        bottom: '5.5rem',   /* above BottomNav on mobile */
        right: '1rem',
        background: '#25D366',
        borderRadius: '999px',
        padding: hovered ? '0.5rem 1rem 0.5rem 0.6rem' : '0.55rem',
        boxShadow: '0 4px 20px rgba(37,211,102,0.45)',
        transition: 'padding 0.25s ease, box-shadow 0.25s ease',
        textDecoration: 'none',
      }}
      aria-label="Contactar por WhatsApp"
    >
      {/* WhatsApp SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="white"
        style={{ flexShrink: 0 }}
      >
        <path d="M16.003 3C9.374 3 4 8.373 4 15.003c0 2.184.592 4.23 1.618 5.988L4 29l8.225-1.594A11.943 11.943 0 0 0 16.003 28C22.63 28 28 22.627 28 15.997 28 9.373 22.63 3 16.003 3zm0 2.18c5.42 0 9.817 4.397 9.817 9.817 0 5.418-4.397 9.817-9.817 9.817a9.787 9.787 0 0 1-5.03-1.389l-.36-.217-3.732.724.747-3.638-.237-.373A9.786 9.786 0 0 1 6.186 15c0-5.42 4.398-9.82 9.817-9.82zm-2.79 5.34c-.22 0-.574.082-.875.41-.3.328-1.146 1.12-1.146 2.731s1.173 3.167 1.337 3.386c.163.218 2.256 3.606 5.566 4.909 2.757 1.088 3.314.872 3.91.818.595-.055 1.92-.784 2.19-1.54.27-.755.27-1.403.19-1.539-.082-.136-.301-.218-.63-.382-.328-.164-1.92-.948-2.22-1.057-.3-.109-.518-.163-.737.163-.218.327-.845 1.058-1.036 1.276-.19.219-.382.245-.71.082-.328-.164-1.386-.51-2.64-1.63-.976-.87-1.635-1.944-1.826-2.272-.19-.328-.02-.505.144-.668.147-.147.328-.382.492-.573.163-.19.218-.327.327-.546.109-.218.055-.41-.027-.573-.082-.164-.727-1.77-1.01-2.425-.245-.573-.5-.494-.683-.503l-.581-.01z" />
      </svg>

      {/* Label - only visible on hover */}
      <span
        style={{
          color: 'white',
          fontWeight: 700,
          fontSize: '0.82rem',
          whiteSpace: 'nowrap',
          maxWidth: hovered ? '130px' : '0',
          overflow: 'hidden',
          transition: 'max-width 0.25s ease',
          lineHeight: 1.2,
        }}
      >
        Soporte NubesMty
      </span>
    </a>
  );
}
